import reducer from "./reducer";
export { default as FiltersDialog } from "./components/index";
export { default as filtersDialogReducerName } from "./constants";
export default reducer;
